import { openInCallModal } from 'actions/InCallModal';

export const DISPLAY_SHARING_SETTINGS_MODAL = 'DISPLAY_SHARING_SETTINGS_MODAL ';

export function displaySharingSettingsModal() {
  return openInCallModal(DISPLAY_SHARING_SETTINGS_MODAL);
}
